<script>
  import MgmConversionRate from "../MgmConversionRate.svelte";
  import Legende from "../Legende.svelte";
  import LegendSixModulesRevenue from "../LegendSixModulesRevenue.svelte";
  import LegendSixModulesChurn from "../LegendSixModulesChurn.svelte";
  import LegendSixModulesStatus from "../LegendSixModulesStatus.svelte";
  import LegendSixModulesConversion from "../LegendSixModulesConversion.svelte";
  import LegendSixModulesChurnQuaterly from "../LegendSixModulesChurnQuaterly.svelte";
  import LegendSixModulesStatusQuaterly from "../LegendSixModulesStatusQuaterly.svelte";
  import LegendSixModulesConversionQuaterly from "../LegendSixModulesConversionQuaterly.svelte";
  import LegendSixModulesRevenueBianual from "../LegendSixModulesRevenueBianual.svelte";
  import WidgetSoldBoluses from "./WidgetSoldBoluses.svelte";
  import WidgetOrderIntake from "./WidgetOrderIntake.svelte";
  import WidgetActivities from "./WidgetActivities.svelte";
  import WidgetSalesTeamKpi from "./WidgetSalesTeamKPI.svelte";
  import WidgetConversionAndAcquisition from "./WidgetConversionAndAcquisition.svelte";
  import LandSelect from "../LandSelect.svelte";
  import AmpelBoxVersionEins from "../AmpelBoxVersionEins.svelte";
  import { nuller_einfuegen_und_to_string } from "../Utils.svelte";

  import {
    get_bianual_data,
    get_current_month_multiplicator,
    get_quaterly_data,
    get_sales_goals,
    get_year_month_key,
    getLastDayOfMonth,
    object_values,
    remove_dataimport_except_when_opportunity,
    two_lists_to_dict,
  } from "../Utils.svelte";

  import { transform_month_data } from "../SixModulesUtils.svelte";
  import { create_prediction } from "../OrThreeChartUtils.svelte";

  import {
    calc_activated_all_removed_not_new_cust_boli,
    calc_balken_progress_table_active_boli_from_events_per_month,
    calc_balken_progress_table_clients,
    calc_balken_progress_table_leads,
    calc_balken_progress_table_opps,
    calc_balken_progress_table_sold_boli,
    calc_balken_progress_table_sold_boli_neu_oder_altkunde,
    calc_open_leads,
    calc_open_leads_per_month,
    calc_order_intake,
    calc_sold_boli_goals_list,
    dateRange,
    dict_to_sum,
    dividieren_dict,
    dividieren_dict_value_durch_dict,
    get_anteilsmaessig_date_filter_range,
    get_month_end_from_key,
    get_month_start_from_key,
    getTopAndBottomValues,
    multiply_dict,
    replace_zero_with_undefined,
    res_partner_filtered_to_dict,
    subtractYears,
  } from "../UtilsBalkenProgress.svelte";
  import WidgetSalesProcess from "./WidgetSalesProcess.svelte";

  export let show_main_content = false;

  export let laender_dict;
  export let activated_all;
  export let marketing_goals;
  export let messenger_res;
  let messenger_res_grouped = false;
  export let res_partner_all;
  export let subscription_all;
  export let lost_leads;
  export let crm_lead_all;
  export let lost_opportunities;
  export let archived;
  export let sale_order_all;
  export let revenue;
  export let clv_targets;
  export let goals_all;

  export let aco_cost;
  export let goal_revenue;
  export let monthly_cost;

  let year_buttons = [];

  let show_legend = false;
  let chart_hoehe_2;

  let marketing_start_date = new Date(2024, 0, 1);
  let marketing_end_date = new Date(2024, 11, 31);
  let selected_year = 2024;
  let active_display_option = "monthly";
  let months = [];
  let month_previous_year = [];
  let current_year = new Date().getFullYear();

  let active_boli_previous_year = {};
  let active_animals_target = 1;

  let market_target_if_not_defined_in_odoo = 0;

  //Sold Boluses:
  export let sold_boluses;
  let chosen_months_astrid = 6;
  let sold_boli_new_custs_dict = {};
  let sold_boli_old_custs_dict = {};
  let laender_dict_targets = 0;
  let marketing_goals_this_year_till_today = {};
  let is_marketing_goal_reached = {};
  let sales_goals = {};
  let marketing_goals_per_month = {};
  let unweighted_prediction = {};
  let weighted_prediction = {};

  //Order Intake:
  let order_intake_top_three_salespersons = false;
  let order_intake_bottom_three_salespersons = false;
  let order_intake_new = {};
  let order_intake_old = {};

  // Sales FUNNEL:
  let table_leads_dict = {};
  let table_opps_dict = {};
  let table_clients_dict = {};
  let table_sold_boli_dict = {};
  let table_leads_dict_previous_year = {};
  let table_opps_dict_previous_year = {};
  let table_clients_dict_previous_year = {};
  let table_sold_boli_dict_previous_year = {};
  let mql_target = 0;
  let opp_target = 0;
  let cus_target = 0;
  let boli_target = 0;

  let mql_target_current = 0;
  let opp_target_current = 0;
  let cus_target_current = 0;
  let boli_target_current = 0;

  // Conversion Rate:
  let conversion_rate_month_data = 0;
  let conversion_rate_month_data_vorjahr = 0;
  let aco_cost_val = 10000000;
  let aco_cost_val_previous_year = 15000000;
  let cac_month_data = {};
  let cac_quaterly_data = [];
  let cac_quaterly_data_previous_year = [];
  let cac_bianual_data = [];
  let cac_bianual_data_previous_year = [];
  let cac_month_data_vorjahr = {};
  let cac_full_year = 0;
  let coc_target = 0;
  let active_animals_end_of_previous_year = 1000;
  let conversion_rate_full_year = 0;
  let conversion_rate_new_attempt = 0;
  let conversion_rate_new_attempt_vorjahr = 0;

  //HELPER:
  let source_cat_dict = [
    { long: "Advertising", short: "Advertising (ADV)", checked: true },
    { long: "Events", short: "Events (EVT)", checked: true },
    { long: "Organic", short: "Organic (ORG)", checked: true },
    { long: "Sales", short: "Sales (SAL)", checked: true },
  ];

  let crm_lead_all_without_data_import;
  let lost_leads_without_data_import;
  let lost_opportunities_without_data_import;
  let archived_without_data_import;

  let ytd_active = true;

  let calculation_finished = false;

  calc_years();

  $: {
    activated_all,
      messenger_res,
      lost_leads,
      crm_lead_all,
      lost_opportunities,
      archived,
      res_partner_all,
      subscription_all,
      sale_order_all,
      revenue,
      aco_cost,
      goal_revenue,
      monthly_cost;
    if (
      activated_all &&
      messenger_res &&
      lost_leads &&
      crm_lead_all &&
      lost_opportunities &&
      archived &&
      res_partner_all &&
      subscription_all &&
      sale_order_all &&
      revenue &&
      aco_cost &&
      goal_revenue &&
      monthly_cost
    ) {
      //DATA IMPORT ENTFERNEN:

      let tmp_without_data_import = remove_dataimport_except_when_opportunity(crm_lead_all, lost_leads, lost_opportunities, archived);

      crm_lead_all_without_data_import = tmp_without_data_import["crm_lead_all"];
      lost_leads_without_data_import = tmp_without_data_import["lost_leads"];
      lost_opportunities_without_data_import = tmp_without_data_import["lost_opportunities"];
      archived_without_data_import = tmp_without_data_import["archived"];

      months = calc_months_array();
      let last_year_start = subtractYears(1, marketing_start_date);
      let last_year_end = subtractYears(1, marketing_end_date);
      month_previous_year = calc_previous_months_array();
      calc_all_months_array();

      //Marketing Goals:
      sum_marketing_goals_over_time();
      calc_targets();
      calc_adressable_market_size_charts();

      let res_partner_dict = res_partner_filtered_to_dict(res_partner_all);

      //Sold Boli:

      //(Get Sales Goals)
      sales_goals = get_sales_goals(goals_all, months);

      //(Get Marketing Goals)
      marketing_goals_per_month = get_marketing_goals_per_month();

      //(Get Marketing Goals Till today)
      marketing_goals_this_year_till_today = {};

      let marketing_goals_per_country = {};
      laender_dict.forEach((land_eintrag) => {
        marketing_goals_per_country[land_eintrag["long"]] = get_marketing_goals_per_month(land_eintrag["short"]);
        marketing_goals_this_year_till_today[land_eintrag["long"]] = get_marketing_goals_for_timeframe(
          land_eintrag["short"],
          marketing_start_date,
          new Date()
        );
      });

      let ret_sold_boli_neu = calc_balken_progress_table_sold_boli_neu_oder_altkunde(
        months,
        sale_order_all,
        res_partner_dict,
        marketing_start_date,
        marketing_end_date,
        laender_dict,
        "neu",
        chosen_months_astrid
      );

      let sold_boli_new_custs_dict_per_country = ret_sold_boli_neu["per_country"];

      let ret_sold_boli_alt = calc_balken_progress_table_sold_boli_neu_oder_altkunde(
        months,
        sale_order_all,
        res_partner_dict,
        marketing_start_date,
        marketing_end_date,
        laender_dict,
        "alt",
        chosen_months_astrid
      );

      sold_boli_old_custs_dict = ret_sold_boli_alt["all"];
      let sold_boli_old_custs_dict_per_country = ret_sold_boli_alt["per_country"];

      is_marketing_goal_reached = {};

      //(Get Gruen/Orange)
      laender_dict.forEach((land_eintrag) => {
        if (selected_year == new Date().getFullYear()) {
          let goal = marketing_goals_this_year_till_today[land_eintrag["long"]];
          let is =
            dict_to_sum(sold_boli_new_custs_dict_per_country[land_eintrag["long"]]) +
            dict_to_sum(sold_boli_old_custs_dict_per_country[land_eintrag["long"]]);
          if (is >= goal) {
            is_marketing_goal_reached[land_eintrag["long"]] = true;
          } else {
            is_marketing_goal_reached[land_eintrag["long"]] = false;
          }
        } else {
          let goal = dict_to_sum(marketing_goals_per_country[land_eintrag["long"]]);
          let is =
            dict_to_sum(sold_boli_new_custs_dict_per_country[land_eintrag["long"]]) +
            dict_to_sum(sold_boli_old_custs_dict_per_country[land_eintrag["long"]]);
          if (is >= goal) {
            is_marketing_goal_reached[land_eintrag["long"]] = true;
          } else {
            is_marketing_goal_reached[land_eintrag["long"]] = false;
          }
        }
      });

      let sold_boli_goals_list = calc_sold_boli_goals_list(goals_all, months);

      let prediction_lists = create_prediction(months, crm_lead_all);

      unweighted_prediction = two_lists_to_dict(months, prediction_lists["unweighted"]);
      weighted_prediction = two_lists_to_dict(months, prediction_lists["weighted"]);

      // Order Intake:

      let ret_order_intake_new = calc_order_intake(sale_order_all, res_partner_dict, months, "neu");
      order_intake_new = ret_order_intake_new["all"];

      let ret_order_intake_old = calc_order_intake(sale_order_all, res_partner_dict, months, "alt");
      order_intake_old = ret_order_intake_old["all"];

      let order_intake_per_salesperson = ret_order_intake_new["per_salesperson"];
      if ("Others" in order_intake_per_salesperson) {
        delete order_intake_per_salesperson["Others"];
      }

      const result = getTopAndBottomValues(order_intake_per_salesperson);

      order_intake_top_three_salespersons = result.topThreeHighest;
      order_intake_bottom_three_salespersons = result.topThreeLowest;

      console.log("Top Three Highest Values:", result.topThreeHighest);
      console.log("Top Three Lowest Values:", result.topThreeLowest);

      // SALES FUNNEL:
      table_leads_dict = calc_balken_progress_table_leads(
        months,
        lost_leads_without_data_import,
        crm_lead_all_without_data_import,
        lost_opportunities_without_data_import,
        archived_without_data_import,
        marketing_start_date,
        marketing_end_date,
        source_cat_dict,
        laender_dict
      );

      table_opps_dict = calc_balken_progress_table_opps(
        months,
        lost_leads_without_data_import,
        crm_lead_all_without_data_import,
        lost_opportunities_without_data_import,
        archived_without_data_import,
        marketing_start_date,
        marketing_end_date,
        source_cat_dict,
        laender_dict
      );

      table_clients_dict = calc_balken_progress_table_clients(months, res_partner_all, laender_dict);

      table_sold_boli_dict = calc_balken_progress_table_sold_boli(
        months,
        sale_order_all,
        marketing_start_date,
        marketing_end_date,
        laender_dict
      );

      table_leads_dict_previous_year = calc_balken_progress_table_leads(
        month_previous_year,
        lost_leads_without_data_import,
        crm_lead_all_without_data_import,
        lost_opportunities_without_data_import,
        archived_without_data_import,
        last_year_start,
        last_year_end,
        source_cat_dict,
        laender_dict
      );

      table_opps_dict_previous_year = calc_balken_progress_table_opps(
        month_previous_year,
        lost_leads_without_data_import,
        crm_lead_all_without_data_import,
        lost_opportunities_without_data_import,
        archived_without_data_import,
        last_year_start,
        last_year_end,
        source_cat_dict,
        laender_dict
      );

      table_clients_dict_previous_year = calc_balken_progress_table_clients(month_previous_year, res_partner_all, laender_dict);

      // console.log("table_clients_dict_previous_year: ", table_clients_dict_previous_year)

      table_sold_boli_dict_previous_year = calc_balken_progress_table_sold_boli(
        month_previous_year,
        sale_order_all,
        last_year_start,
        last_year_end,
        laender_dict
      );

      //Conversion Rate:

      let open_new_leads = calc_open_leads_per_month(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        marketing_start_date,
        marketing_end_date
      );
      let open_new_leads_previous_year = calc_open_leads_per_month(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        month_previous_year,
        laender_dict,
        source_cat_dict,
        marketing_start_date,
        marketing_end_date
      );

      conversion_rate_month_data = multiply_dict(dividieren_dict(replace_zero_with_undefined(table_clients_dict), open_new_leads), 100);
      conversion_rate_month_data_vorjahr = multiply_dict(
        dividieren_dict(table_clients_dict_previous_year, open_new_leads_previous_year),
        100
      );

      let open_new_leads_whole_year = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        marketing_start_date,
        marketing_end_date
      );

      let open_new_leads_q1 = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year, 0, 1),
        new Date(selected_year, 2, 31)
      );
      let open_new_leads_q2 = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year, 3, 1),
        new Date(selected_year, 5, 30)
      );
      let open_new_leads_q3 = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year, 6, 1),
        new Date(selected_year, 8, 30)
      );
      let open_new_leads_q4 = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year, 9, 1),
        new Date(selected_year, 11, 31)
      );

      let open_new_leads_b1 = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year, 0, 1),
        new Date(selected_year, 5, 30)
      );
      let open_new_leads_b2 = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year, 6, 1),
        new Date(selected_year, 11, 31)
      );

      let open_new_leads_q1_vorjahr = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year - 1, 0, 1),
        new Date(selected_year, 2, 31)
      );
      let open_new_leads_q2_vorjahr = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year - 1, 3, 1),
        new Date(selected_year, 5, 30)
      );
      let open_new_leads_q3_vorjahr = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year - 1, 6, 1),
        new Date(selected_year, 8, 30)
      );
      let open_new_leads_q4_vorjahr = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year - 1, 9, 1),
        new Date(selected_year, 11, 31)
      );

      let open_new_leads_b1_vorjahr = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year - 1, 0, 1),
        new Date(selected_year, 5, 30)
      );
      let open_new_leads_b2_vorjahr = calc_open_leads(
        crm_lead_all_without_data_import,
        lost_leads,
        lost_opportunities,
        archived,
        months,
        laender_dict,
        source_cat_dict,
        new Date(selected_year - 1, 6, 1),
        new Date(selected_year, 11, 31)
      );

      conversion_rate_full_year = (dict_to_sum(table_clients_dict) / open_new_leads_whole_year) * 100;

      let clients_count = transform_month_data(object_values(table_clients_dict), time_modus);
      let clients_count_vorjahr = transform_month_data(object_values(table_clients_dict_previous_year), time_modus);

      if (time_modus == "monthly") {
        conversion_rate_new_attempt = object_values(conversion_rate_month_data);
        conversion_rate_new_attempt_vorjahr = object_values(conversion_rate_month_data_vorjahr);
      }
      if (time_modus == "quaterly") {
        conversion_rate_new_attempt = [
          (clients_count[0] / open_new_leads_q1) * 100,
          (clients_count[1] / open_new_leads_q2) * 100,
          (clients_count[2] / open_new_leads_q3) * 100,
          (clients_count[3] / open_new_leads_q4) * 100,
        ];
        conversion_rate_new_attempt_vorjahr = [
          (clients_count_vorjahr[0] / open_new_leads_q1_vorjahr) * 100,
          (clients_count_vorjahr[1] / open_new_leads_q2_vorjahr) * 100,
          (clients_count_vorjahr[2] / open_new_leads_q3_vorjahr) * 100,
          (clients_count_vorjahr[3] / open_new_leads_q4_vorjahr) * 100,
        ];
      }
      if (time_modus == "biannual") {
        conversion_rate_new_attempt = [
          (clients_count[0] / open_new_leads_b1_vorjahr) * 100,
          (clients_count[1] / open_new_leads_b2_vorjahr) * 100,
        ];
        conversion_rate_new_attempt_vorjahr = [
          (clients_count_vorjahr[0] / open_new_leads_b1) * 100,
          (clients_count_vorjahr[1] / open_new_leads_b2) * 100,
        ];
      }

      active_animals_end_of_previous_year = active_boli_previous_year[(parseInt(selected_year) - 1).toString() + "-" + "12"];
      // console.log("active_animals_end_of_previous_year: ", active_animals_end_of_previous_year)

      let activated_all_removed_not_new_cust_boli = calc_activated_all_removed_not_new_cust_boli(activated_all);
      let new_boli_new_customers = calc_balken_progress_table_active_boli_from_events_per_month(
        months,
        activated_all_removed_not_new_cust_boli,
        marketing_start_date,
        marketing_end_date,
        laender_dict
      );

      let new_boli_new_customers_previous_year = calc_balken_progress_table_active_boli_from_events_per_month(
        month_previous_year,
        activated_all_removed_not_new_cust_boli,
        marketing_start_date,
        marketing_end_date,
        laender_dict
      );

      // console.log("new_boli_new_customers: ", new_boli_new_customers)

      aco_cost.forEach((mg) => {
        if (mg["start_date"].substring(0, 4) == selected_year.toString()) {
          aco_cost_val = mg["target_goal"];
        }
        if (mg["start_date"].substring(0, 4) == (selected_year - 1).toString()) {
          aco_cost_val_previous_year = mg["target_goal"];
        }
      });

      // console.log("new_boli_new_customers: ", new_boli_new_customers)
      // console.log("aco_cost_val: ", aco_cost_val)

      cac_month_data = dividieren_dict_value_durch_dict(aco_cost_val / 12, new_boli_new_customers);
      cac_month_data_vorjahr = dividieren_dict_value_durch_dict(aco_cost_val_previous_year / 12, new_boli_new_customers_previous_year);

      //neue daily korrektur cac
      if (selected_year == new Date().getFullYear()) {
        let current_month_key = get_year_month_key(new Date());
        let day_of_month = new Date().getDate();
        let number_of_days_in_month = new Date(selected_year, new Date().getMonth() + 1, 0).getDate();

        cac_month_data[current_month_key] =
          ((aco_cost_val / 12) * day_of_month) / number_of_days_in_month / new_boli_new_customers[current_month_key];
      }

      cac_quaterly_data = get_quaterly_data(aco_cost_val / 4, new_boli_new_customers, months);
      // console.log("cac_quaterly_data: ", cac_quaterly_data)
      cac_quaterly_data_previous_year = get_quaterly_data(
        aco_cost_val_previous_year / 4,
        new_boli_new_customers_previous_year,
        month_previous_year
      );
      // console.log("cac_quaterly_data_previous_year: ", cac_quaterly_data_previous_year)

      cac_bianual_data = get_bianual_data(aco_cost_val / 2, new_boli_new_customers, months);
      cac_bianual_data_previous_year = get_bianual_data(
        aco_cost_val_previous_year / 2,
        new_boli_new_customers_previous_year,
        month_previous_year
      );

      // console.log("cac_bianual_data: ", cac_bianual_data)
      // console.log("cac_bianual_data_previous_year: ", cac_bianual_data_previous_year)

      cac_full_year = aco_cost_val / dict_to_sum(new_boli_new_customers);
      if (selected_year == new Date().getFullYear()) {
        cac_full_year = (aco_cost_val * day_of_year(new Date())) / 365 / dict_to_sum(new_boli_new_customers);
      }

      let current_month_index = "";
      if (new Date().getMonth() + 1 < 10) {
        current_month_index = new Date().getFullYear().toString() + "-0" + (new Date().getMonth() + 1).toString();
      }

      // filtering sold boluses numbers to new and reorder
      let sold_bolus_filtered = sold_boluses.reduce(function (res, value) {
        let month_index = value.year.toString() + "-" + nuller_einfuegen_und_to_string(value.month.toString());
        if (!res["new"]) {
          res["new"] = {};
        }
        if (!res["reorder"]) {
          res["reorder"] = {};
        }
        if (value.order_type != "Reorder") {
          if (!res["new"][month_index]) {
            res["new"][month_index] = 0;
          }
          res["new"][month_index] += value.sold_boluses;
        } else {
          if (!res["reorder"][month_index]) {
            res["reorder"][month_index] = 0;
          }
          res["reorder"][month_index] += value.sold_boluses;
        }
        return res;
      }, {});

      let sold_bolus_new = sold_bolus_filtered["new"];
      let sold_bolus_reorder = sold_bolus_filtered["reorder"];

      let sold_bolus_new_filtered = Object.fromEntries(Object.entries(sold_bolus_new).filter(([key, value]) => months.includes(key)));
      let sold_bolus_reorder_filtered = Object.fromEntries(
        Object.entries(sold_bolus_reorder).filter(([key, value]) => months.includes(key))
      );

      sold_boli_new_custs_dict = sold_bolus_new_filtered;
      sold_boli_old_custs_dict = sold_bolus_reorder_filtered;

      // console.log("cac_month_data: ", cac_month_data)
      // console.log("cac_full_year: ", cac_full_year)

      calculation_finished = true;

      console.log("laender_dict: ", laender_dict);
    }
  }

  let time_modus = "monthly";
  let include_vorjahr = true;

  function calc_previous_months_array() {
    let last_year_start = subtractYears(1, marketing_start_date);
    let last_year_end = subtractYears(1, marketing_end_date);
    var months = dateRange(last_year_start, last_year_end);

    return months;
  }

  function calc_months_array() {
    var months = dateRange(marketing_start_date, marketing_end_date);

    return months;
  }

  function calc_all_months_array() {
    var months = dateRange(new Date(2016, 0, 1), new Date());

    return months;
  }

  function set_time_modus(s) {
    //console.log('s: ', s);
    active_display_option = s;
    time_modus = s;
  }

  function set_include_vorjahr(v) {
    include_vorjahr = !v;
  }

  function day_of_year(date) {
    var now = date;
    var start = new Date(now.getFullYear(), 0, 0);
    var diff = now - start;
    var oneDay = 1000 * 60 * 60 * 24;
    var day = Math.floor(diff / oneDay);

    return day;
  }

  function calc_years() {
    let current_year = new Date().getFullYear();
    var first_year = 2021;
    year_buttons = [];
    while (current_year >= first_year) {
      year_buttons.push(current_year);
      current_year = current_year - 1;
    }
  }

  function select_year(y) {
    selected_year = y;

    if (y == new Date().getFullYear()) {
      ytd_active = true;
    } else {
      ytd_active = false;
    }

    marketing_start_date = new Date(y, 0, 1);
    marketing_end_date = new Date(y, 11, 31);
  }

  function show_legend_sitch() {
    show_legend = !show_legend;
  }

  function get_marketing_keys() {
    let list_of_keys = [];
    marketing_goals.forEach((mg) => {
      var key = mg["challenge_name"];
      if (!list_of_keys.includes(key)) {
        list_of_keys.push(key);
      }
    });

    return list_of_keys;
  }

  function calc_targets() {
    var tmp_dict = {};

    laender_dict.forEach((land) => {
      tmp_dict[land["short"]] = {};
    });

    var new_leads_target = 0;
    var sold_boli_target = {};
    var acq_cost = 0;
    var acq_cost_helper = 0;

    marketing_goals.forEach((goal) => {
      if (!goal["start_date"]) {
        return;
      }

      var date_index = goal["start_date"].substring(0, 7);

      if (goal["challenge_name"].includes("AMS ")) {
        if (goal["goal_name"].includes("Cows")) {
          tmp_dict[goal["challenge_name"].split(" ")[1]]["AMS"] = goal["target_goal"]
            ? goal["target_goal"]
            : market_target_if_not_defined_in_odoo;
        }
      }

      if (goal["challenge_name"].includes("AMT ")) {
        if (goal["start_date"].substring(0, 4) == marketing_end_date.getFullYear().toString()) {
          tmp_dict[goal["challenge_name"].split(" ")[1]]["AMT"] = goal["target_goal"]
            ? goal["target_goal"]
            : market_target_if_not_defined_in_odoo;
        }
      }

      parseInt(months[0].substring(0, 4)) == new Date().getFullYear() && date_index.substring(0, 4) == parseInt(months[0].substring(0, 4));

      let filter_end = marketing_end_date;

      if (ytd_active) {
        filter_end = getLastDayOfMonth(new Date());
      }

      if (goal["challenge_name"].includes("ACQCost") && goal["start_date"].substring(0, 4) == marketing_start_date.getFullYear()) {
        acq_cost = goal["target_goal"];
      }

      if (
        goal["challenge_name"].includes("ACQCost") &&
        parseInt(goal["start_date"].substring(0, 4)) >= marketing_start_date.getFullYear() &&
        parseInt(goal["start_date"].substring(0, 4)) <= marketing_end_date.getFullYear()
      ) {
        // acq_cost_helper += goal['target_goal']
        acq_cost_helper += get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
      }

      // acq_cost_helper

      if (goal["challenge_name"].includes("LEAD_TARGET")) {
        new_leads_target += get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
      }

      if (
        goal["name"] == "SOLD_BOL_TARGET 2023 MKT" ||
        goal["name"] == "SOLD_BOL_TARGET 2022 MKT" ||
        goal["name"] == "SOLD_BOL_TARGET 2021 MKT"
      ) {
        return;
      }

      if (goal["challenge_name"].includes("SOLD_BOL_TARGET")) {
        var country_short = goal["name"].split("MKT_")[1].split("_")[0];
        if (country_short in sold_boli_target) {
          sold_boli_target[country_short] += get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
        } else {
          sold_boli_target[country_short] = get_anteilsmaessig_date_filter_range(goal, months, marketing_start_date, filter_end);
        }
      }
    });

    laender_dict_targets = tmp_dict;
  }

  function calc_adressable_market_size_charts() {
    // var tmp_dict = {};
    // var tmp_active_boli_end_of_timeframe = {};
    // laender_dict.forEach((land) => {
    //   if (!land['checked']) {
    //     return;
    //   }
    //   var active_boli = 0;
    //   total_tms += laender_dict_targets[land['short']]['AMT'];
    // });
  }

  function get_marketing_goals_for_timeframe(country_short = false, from, to) {
    let ret = 0;

    marketing_goals.forEach((mg) => {
      if (!mg["start_date"]) {
        return;
      }

      mg["start_date"].substring(0, 7);
      new Date(mg["start_date"]);

      if (
        mg["name"] == "SOLD_BOL_TARGET 2023 MKT" ||
        mg["name"] == "SOLD_BOL_TARGET 2022 MKT" ||
        mg["name"] == "SOLD_BOL_TARGET 2021 MKT"
      ) {
        return;
      }

      if (!mg["name"].includes("SOLD_BOL_TARGET MKT")) {
        return;
      }

      if (country_short) {
        // console.log("mg: ", mg)
        var land_kuerzel = mg["name"].split("SOLD_BOL_TARGET MKT_")[1].split("_")[0];

        if (land_kuerzel == "AUS") {
          land_kuerzel = "AU";
        }

        if (land_kuerzel != country_short) {
          return;
        }
      }

      ret += get_anteilsmaessig_date_filter_range(mg, false, from, to);
    });

    return ret;
  }

  function get_marketing_goals_per_month(country_short = false) {
    let marketing_goals_per_month = {};

    months.forEach((m) => {
      marketing_goals_per_month[m] = 0;
    });

    var sum = 0;

    months.forEach((m) => {
      marketing_goals.forEach((mg) => {
        if (!mg["start_date"]) {
          return;
        }

        mg["start_date"].substring(0, 7);
        new Date(mg["start_date"]);

        if (
          mg["name"] == "SOLD_BOL_TARGET 2023 MKT" ||
          mg["name"] == "SOLD_BOL_TARGET 2022 MKT" ||
          mg["name"] == "SOLD_BOL_TARGET 2021 MKT"
        ) {
          return;
        }

        if (!mg["name"].includes("SOLD_BOL_TARGET MKT")) {
          return;
        }

        if (country_short) {
          // console.log("mg: ", mg)
          var land_kuerzel = mg["name"].split("SOLD_BOL_TARGET MKT_")[1].split("_")[0];

          if (land_kuerzel == "AUS") {
            land_kuerzel = "AU";
          }

          if (land_kuerzel != country_short) {
            return;
          }
        }

        marketing_goals_per_month[m] += get_anteilsmaessig_date_filter_range(
          mg,
          false,
          get_month_start_from_key(m),
          get_month_end_from_key(m)
        );

        if (get_anteilsmaessig_date_filter_range(mg, false, get_month_start_from_key(m), get_month_end_from_key(m)) != 0) {
          // console.log("Ergebnis für ", m)
          // console.log("mg: ", mg)
          // console.log(get_anteilsmaessig_date_filter_range(mg, false, get_month_start_from_key(m), get_month_end_from_key(m)))

          sum += get_anteilsmaessig_date_filter_range(mg, false, get_month_start_from_key(m), get_month_end_from_key(m));
        }
      });
    });

    // console.log("marketing target sum für Kontrolle: ", sum)
    return marketing_goals_per_month;
  }

  function sum_marketing_goals_over_time() {
    let marketing_keys = get_marketing_keys();

    let marketing_target_sums = {};
    let marketing_target_year_sums = {};

    marketing_target_sums["Boli Target"] = 0;
    marketing_target_sums["Boli Target"] = 0;

    marketing_target_year_sums["Boli Target"] = 0;

    marketing_keys.forEach((k) => {
      marketing_target_sums[k] = 0;
    });

    marketing_keys.forEach((k) => {
      marketing_target_year_sums[k] = 0;
    });

    get_year_month_key(new Date());
    get_current_month_multiplicator();

    var selected_year = marketing_start_date.getFullYear().toString();
    var selected_last_year = (marketing_end_date.getFullYear() - 1).toString();

    let ACQCost_last_year = 0;

    //console.log('months: ', months);

    marketing_goals.forEach((mg) => {
      if (!mg["start_date"]) {
        return;
      }

      var date_index = mg["start_date"].substring(0, 7);
      new Date(mg["start_date"]);
      var target_goal = mg["target_goal"];
      var key = mg["challenge_name"];

      if (
        mg["name"] == "SOLD_BOL_TARGET 2023 MKT" ||
        mg["name"] == "SOLD_BOL_TARGET 2022 MKT" ||
        mg["name"] == "SOLD_BOL_TARGET 2021 MKT"
      ) {
        return;
      }

      //GESAMTES YEAR:
      if (date_index.substring(0, 4) == selected_year || date_index.substring(0, 4) == marketing_end_date.getFullYear().toString()) {
        marketing_target_year_sums[key] += target_goal;
      }

      if (
        (get_year_month_key(marketing_start_date).substring(0, 4) == selected_last_year ||
          get_year_month_key(marketing_end_date).substring(0, 4) == selected_year) &&
        key == "ACQCost"
      ) {
        ACQCost_last_year += target_goal;
      }
      let is_current_year =
        parseInt(months[0].substring(0, 4)) == new Date().getFullYear() &&
        date_index.substring(0, 4) == parseInt(months[0].substring(0, 4));

      let filter_end = marketing_end_date;

      if (marketing_end_date.getFullYear() == new Date().getFullYear()) {
        filter_end = new Date();
        filter_end.setDate(filter_end.getDate() - 1);
      }

      if (is_current_year) {
        marketing_target_sums[key] += get_anteilsmaessig_date_filter_range(mg, months, marketing_start_date, filter_end);
        if (key == "LEAD_TARGET") {
          console.log("lead target: ", get_anteilsmaessig_date_filter_range(mg, months, marketing_start_date, filter_end));
          console.log("mg: ", mg);
        }
      } else {
        marketing_target_sums[key] += get_anteilsmaessig_date_filter_range(mg, months, marketing_start_date, filter_end);
        if (key == "LEAD_TARGET NICHT CURRENT YEAR") {
          console.log("lead target: ", get_anteilsmaessig_date_filter_range(mg, months, marketing_start_date, filter_end));
          console.log("mg: ", mg);
        }
      }
    });

    mql_target_current = marketing_target_sums["LEAD_TARGET"];
    opp_target_current = marketing_target_sums["OPP_TARGET"];
    cus_target_current = marketing_target_sums["CUS_TARGET"];
    boli_target_current = marketing_target_sums["SOLD_BOL_TARGET"];

    console.log("mql_target_current: ", mql_target_current);
    console.log("cus_target_current: ", cus_target_current);

    mql_target = marketing_target_year_sums["LEAD_TARGET"];
    opp_target = marketing_target_year_sums["OPP_TARGET"];
    cus_target = marketing_target_year_sums["CUS_TARGET"];
    boli_target = marketing_target_year_sums["SOLD_BOL_TARGET"];
  }
</script>

<nav class="navbar navbar-expand navbar-light navbar-bg {show_main_content === true ? 'div' : 'hiddenClass'}">
  <div class="col">
    <div class="row flex">
      <div class="row">
        <div class="col-12">
          <div class="">
            <div class="">
              <div class="row">
                <div class="col-4">
                  <b>Select timeframe</b>
                </div>
                <div class="col-4">
                  <b>Display options</b>
                </div>
                <div class="col-4">
                  <b>Select countries</b>
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  {#each year_buttons as y}
                    <div on:click={() => select_year(y)} class="btn {y == selected_year ? 'active' : 'btn'}">
                      {y}
                      {#if y == new Date().getFullYear()}YTD{/if}
                    </div>
                  {/each}
                  <div on:click={() => select_year(y)} class="btn">NSM</div>
                  <div on:click={() => select_year(y)} class="btn">LTM</div>
                </div>

                <div class="col-5 trenner-links" style="">
                  <div on:click={() => set_time_modus("monthly")} class="btn {active_display_option == 'monthly' ? 'active' : 'btn'}">
                    monthly
                  </div>
                  <div on:click={() => set_time_modus("quaterly")} class="btn {active_display_option == 'quaterly' ? 'active' : 'btn'}">
                    quaterly
                  </div>
                  <div on:click={() => set_time_modus("biannual")} class="btn {active_display_option == 'biannual' ? 'active' : 'btn'}">
                    biannually
                  </div>
                  <div on:click={() => set_include_vorjahr(include_vorjahr)} class="btn {include_vorjahr ? 'active' : 'btn'}">
                    include previous year
                  </div>
                </div>

                <div class="col-4 trenner-links" style="">
                  <div class="col-2" />
                  <div class="col-10">
                    <LandSelect bind:laender_dict />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

{#if calculation_finished}
  <main class={show_main_content === true ? "content div" : "hiddenClass"} style="padding: 5px;">
    <div class="row haupt">
      <div class="col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4" style="padding-top:10px">
        <div class="card h-100 green-border" style="position:relative;">
          <div class="" style="position: absolute; left:5%; bottom: 5px; font-size: 8px;">k</div>
          <div class="card-header  d-flex justify-content-between align-items-center" style="padding-bottom: 0px;">
            <h5 class="card-title">Sold boluses</h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                <!-- <LegendSixModulesActiveBoluses /> -->
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 10px;">
            <div class="">
              <WidgetSoldBoluses
                {time_modus}
                {sold_boli_new_custs_dict}
                {sold_boli_old_custs_dict}
                {weighted_prediction}
                {unweighted_prediction}
                sold_boli_current={dict_to_sum(sold_boli_new_custs_dict) + dict_to_sum(sold_boli_old_custs_dict)}
                year={marketing_start_date.getFullYear()}
                {laender_dict}
                {is_marketing_goal_reached}
                sold_bolus_current_marketing_target={selected_year == new Date().getFullYear()
                  ? dict_to_sum(marketing_goals_this_year_till_today)
                  : dict_to_sum(marketing_goals)}
                marketing_target={marketing_goals_per_month}
                sales_target={sales_goals}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4" style="padding-top:10px">
        <div class="card h-100 green-border" style="position:relative;">
          <div class="" style="position: absolute; left:5%; bottom: 5px; font-size: 8px;">m€</div>
          <div class="card-header  d-flex justify-content-between align-items-center" style="padding-bottom: 0px;">
            <h5 class="card-title">Order Intake</h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;" />
            </div>
          </div>
          <div class="card-body" style="padding-top: 10px; height:0px; padding-bottom: 70%;">
            <WidgetOrderIntake
              {time_modus}
              year={marketing_start_date.getFullYear()}
              {order_intake_top_three_salespersons}
              {order_intake_bottom_three_salespersons}
              {order_intake_new}
              {order_intake_old}
            />
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4" style="padding-top:10px">
        <div class="card h-100 green-border" style="position:relative;">
          <div class="" style="position: absolute; left:5%; bottom: 5px; font-size: 8px;">m€</div>
          <div class="card-header  d-flex justify-content-between align-items-center" style="padding-bottom: 0px;">
            <h5 class="card-title">Sold boluses</h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                <!-- <LegendSixModulesActiveBoluses /> -->
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 10px;">
            <div class="row">
              <WidgetActivities
                {time_modus}
                {sold_boli_new_custs_dict}
                {sold_boli_old_custs_dict}
                {weighted_prediction}
                {unweighted_prediction}
                sold_boli_current={dict_to_sum(sold_boli_new_custs_dict) + dict_to_sum(sold_boli_old_custs_dict)}
                year={marketing_start_date.getFullYear()}
                {laender_dict}
                {is_marketing_goal_reached}
                sold_bolus_current_marketing_target={selected_year == new Date().getFullYear()
                  ? dict_to_sum(marketing_goals_this_year_till_today)
                  : dict_to_sum(marketing_goals)}
                marketing_target={marketing_goals_per_month}
                sales_target={sales_goals}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row haupt">
      <div class="col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4" style="padding-top:10px">
        <div class="card h-100 green-border" style="position:relative">
          <div class="card-header  d-flex justify-content-between align-items-center" style="padding-bottom: 0px;">
            <h5 class="card-title">Sales team KPI</h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if time_modus == "monthly"}
                  <LegendSixModulesChurn />
                {:else}
                  <LegendSixModulesChurnQuaterly />
                {/if}
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 10px;">
            <div class="row">
              <WidgetSalesTeamKpi />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4" style="padding-top:10px">
        <div class="card h-100 green-border" style="position:relative;">
          <div class="card-header  d-flex justify-content-between align-items-center" style="padding-bottom: 0px;">
            <h5 class="card-title">Sales process</h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if time_modus == "monthly"}
                  <LegendSixModulesStatus />
                {:else}
                  <LegendSixModulesStatusQuaterly />
                {/if}
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 10px;">
            <div class="card-body">
              <div class="row">
                <WidgetSalesProcess />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4" style="padding-top:10px">
        <div class="card h-100 green-border" style="position:relative;">
          <div class="card-header  d-flex justify-content-between align-items-center" style="padding-bottom: 0px;">
            <h5 class="card-title">Conversion and Acquisition</h5>
            <div class="info-circle my-auto">
              <div class="my-auto info-i">i</div>
              <div class="info-box" style="color: #000000;">
                {#if time_modus == "monthly"}
                  <LegendSixModulesConversion />
                {:else}
                  <LegendSixModulesConversionQuaterly />
                {/if}
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 10px;">
            <WidgetConversionAndAcquisition
              {time_modus}
              {include_vorjahr}
              {conversion_rate_month_data}
              {conversion_rate_month_data_vorjahr}
              {cac_month_data}
              {cac_quaterly_data}
              {cac_quaterly_data_previous_year}
              {cac_bianual_data}
              {cac_bianual_data_previous_year}
              coc_target={coc_target / (active_animals_target - active_animals_end_of_previous_year)}
              {cac_month_data_vorjahr}
              year={selected_year}
              conversion_rate_target={(cus_target && mql_target ? cus_target / mql_target : 0) * 100}
              {conversion_rate_full_year}
              {conversion_rate_new_attempt}
              {conversion_rate_new_attempt_vorjahr}
              {chart_hoehe_2}
              {cac_full_year}
            />
          </div>
        </div>
      </div>
    </div>

    <div>
      <div on:click={show_legend_sitch} class="card h-100 " style="margin-top: 20px; padding:5px;">
        {#if show_legend}
          <div style="color:gray;">▲ Legend</div>
        {:else}
          <div style="color:gray;">▼ Legend</div>
        {/if}
        <div class={show_legend ? "shownClassRow" : "hiddenClassRow"}>
          <Legende {time_modus} />
        </div>
      </div>
    </div>
  </main>
{/if}

<style>
  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    margin-left: 20px;
    /*text-transform: uppercase;*/
    top: inherit;
    left: inherit;
    display: none;
    z-index: 10;
    padding: 15px 20px 0px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 30px;
    left: 30px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass {
    display: inline-block;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }

  .green-border {
    /*background-color: #fbfcfc;*/
    border-width: 0.25px;
    border-style: solid;
    border-color: #afc5b9 !important;
  }

  .month-year {
    width: 100px;
    border: grey 0.25pt solid;
    border-radius: 5px;
    font-size: 12px;
  }

  .trenner-links {
    border-left: 3px solid #d9d9d9;
  }

  .half {
    width: 50px;
  }

  .hiddenClassGaunt {
    visibility: hidden;
  }

  .hiddenClass {
    visibility: hidden;
    display: none;
  }

  .hiddenClassRow {
    /*visibility: hidden;
    display: none;
    opacity:  0;
    transition: visibility 2s, opacity 2s linear;*/

    max-height: 0;
    opacity: 0;
    transition: opacity 0.5s ease-out;
    transition: max-height 0.5s ease-in;
  }

  .shownClassRow {
    max-height: auto;

    opacity: 1;
    transition: max-height 0.5s ease-in;
    transition: opacity 0.5s ease-in;
  }

  .help {
    position: absolute;
    right: 0;
    top: 0;
    width: 22px;
    height: 15px;
    z-index: 100;
  }
  .funnel {
    max-width: 100%;
  }

  .funnelParentNumbers {
    display: flex;
    flex-direction: column;
  }

  .flex-2 {
    position: relative;
    flex: 1;
  }
  .flex-2-child {
    display: flex;
    align-items: stretch;
    height: 16.8%;
  }

  .gauge_boli {
    width: 100%;
  }

  #sold_more_then_boli {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #current_boli {
    width: 50px;
    height: 20px;
    background: #fff04d;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #should_be_here {
    width: 50px;
    height: 20px;
    background: #03fcf4;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .reddiv {
    width: 50px;
    height: 20px;
    background: #990e05;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .greendiv {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .active {
    color: #333;
    border-color: #325cff;
  }

  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .vertical-center-churn {
    margin: 0;
    position: absolute;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 9px;
    white-space: nowrap;
  }

  .rotate {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }

  main {
    /*background-color: #c5e0b4;*/
  }
</style>
